export const CRS_LOGIN_MUTATION_CACHE_KEY = 'crs-login-mutation-cache-key'
